import React, { useState } from "react";
// import _ from "lodash";
import { amountFormat } from "../../utils";
import { useHistory } from "react-router-dom";
import BaseCurrency from "../Common/BaseCurrency";

const PendingAvancesCard = ({ dashboard }) => {
  const [isPending, setIsPending] = useState(true);
  const history = useHistory();
  return (
    <div className="pending-card">
      <h2 className="flex-between">
        <span>Pending Advances</span>
        <span
          className="active-text cursor"
          onClick={() => {
            history.push("/advances", {
              filter: isPending ? "pending_approval" : "pending_recovery"

            });
          }}
        >
          View all
        </span>
      </h2>
      <div className="tabs">
        <div
          className={`${isPending ? "active" : ""} cursor`}
          onClick={() => setIsPending(true)}
        >
          For Approval <br /> ({dashboard?.pending_counts?.advance_pending_approval}{" "}
          advances)
        </div>
        <div
          className={`${!isPending ? "active" : ""} cursor`}
          onClick={() => setIsPending(false)}
        >
          To be Recovered <br /> ({dashboard?.pending_counts?.advance_recovered} advances)
        </div>
      </div>
      <div className="mt1">
        <div className="titles">
          <span>User</span>
          <span>Amount</span>
        </div>
        {dashboard?.[
          isPending ? "advance_pending_approval" : "advance_recovered"
        ]?.length > 0 ? dashboard?.[
          isPending ? "advance_pending_approval" : "advance_recovered"
        ]?.map((ele) => (
          <div className="values">
            <aside>
              {/* <b> 14 May 2022</b> <br /> */}
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  // cursor: "pointer"
                }}
                onClick={() => {
                  // history.push("/advance-details/" + ele.advance_id)
                }}
              >
                <span className="circle">{ele.user_name?.[0]}</span>
                {ele.user_name}
              </span>
            </aside>
            <aside><BaseCurrency />{amountFormat(ele.amount)}</aside>
          </div>
        )) : <div className="no-data">
          <span>No Pending advances</span>
        </div>}
      </div>
    </div>
  );
};

export default PendingAvancesCard;
